import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState , BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Policy } from '../_models/policy.model';
import { Ramo, SubRamo, Mes, Anyo, Genero, Fumador, TipoRiesgo } from '../_models/general.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { catchError, finalize, tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';
import {saveAs as importedSaveAs} from "file-saver";
import { Config } from "../_models/config.model"
import JsFileDownloader from 'js-file-downloader';

declare var require: any
const FileSaver = require('file-saver');

declare var download: any;

const DEFAULT_STATE: ITableState = {
  filter: {},
  paginator: new PaginatorState(),
  sorting: new SortState(),
  searchTerm: '',
  grouping: new GroupingState(),
  entityId: undefined,
  paramsGet: "",
  paramsPost: {}
};

@Injectable({
  providedIn: 'root'
})
export class HelperServices extends TableService<Policy> implements OnDestroy {
  
  apiUrls = {
    getLinkCotizador : `${environment.url}/${environment.apiUrl}/Producer/get_link_cotizador?`,
    getSiNo : `${environment.url}/${environment.apiUrl}/Generico/get_sino?`,
    getRamo : `${environment.url}/${environment.apiUrl}/Generico/get_ramos?`,
    getSubRamo : `${environment.url}/${environment.apiUrl}/Generico/get_sub_ramos?`,
    getMes : `${environment.url}/${environment.apiUrl}/Generico/get_meses?`,
    getAnyo : `${environment.url}/${environment.apiUrl}/Generico/get_anos?`,
    getConfig : `${environment.url}/${environment.apiUrl}/Generico/get_configuracion_parametros?`,
    getMenuPermission : `${environment.url}/${environment.apiUrl}/Entidad/get_permiso_menu?`,
    getCompaniaSeguros : `${environment.url}/${environment.apiUrl}/Generico/get_compania_seguros?`,
    getSexo : `${environment.url}/${environment.apiUrl}/Generico/get_sexo?`,
    getFumador : `${environment.url}/${environment.apiUrl}/Generico/get_fumador?`,
    getTipoRiesgo: `${environment.url}/${environment.apiUrl}/Generico/get_tipo_riesgo?`,
    getTipoPago: `${environment.url}/${environment.apiUrl}/Generico/get_tipo_pago?`,
    getFrecuencia: `${environment.url}/${environment.apiUrl}/Generico/get_frecuencia_pago?`,
    getPais: `${environment.url}/${environment.apiUrl}/Generico/get_pais?`,
    getCiudad: `${environment.url}/${environment.apiUrl}/Generico/get_ciudad?`,
    getEstado: `${environment.url}/${environment.apiUrl}/Generico/get_estado?`,
    getCodigoPostal: `${environment.url}/${environment.apiUrl}/Generico/get_codigo_postal?`,
    getTipoLogin: `${environment.url}/${environment.apiUrl}/Generico/get_tipo_login?`,
    getPrefijoPoliza: `${environment.url}/${environment.apiUrl}/Generico/get_prefijo_poliza?`,
    postCrearUsuarioMode1: `${environment.url}/${environment.apiUrl}/Entidad/post_crear_usuario?`,
    postCrearUsuarioMode2: `${environment.url}/${environment.apiUrl}/Entidad/post_crear_usuario_ii?`,
    getCodigoLogin: `${environment.url}/${environment.apiUrl}/Entidad/get_codigo_login?`,
    getLogin: `${environment.url}/${environment.apiUrl}/Entidad/get_login_email_telefono?`,
    getParentesco : `${environment.url}/${environment.apiUrl}/Generico/get_parentesco?`,
    getTipoFiltroInteres: `${environment.url}/${environment.apiUrl}/Generico/get_tipo_filtro_interes?`,
    postEnviarDocumentosPolizas: `${environment.url}/${environment.apiUrl}/Producer/post_enviar_documentos_polizas?`,
  }

  API_URL = `${environment.url}/${environment.apiUrl}/Producer/get_Listados_De_Polizas`;
  constructor(@Inject(HttpClient) http, private auth: AuthService) {
    super(http);
  }

  // READ
  async getLinkCotizador(paramsGet: string = "") {
    return await this.http.get(this.apiUrls.getLinkCotizador + paramsGet,  {headers: this.auth.httpHeaders}).toPromise();
  }

  async getConfig(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getConfig + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getSiNo(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getSiNo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getTipoFiltroInteres(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getTipoFiltroInteres + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getCodigoLogin(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getCodigoLogin + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getParentesco(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getParentesco + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async postCrearUsuario2(paramsGet: string = "") {
    return await this.http.post<any>(this.apiUrls.postCrearUsuarioMode1 + paramsGet, {}, {}).toPromise();
  }

  async postCrearUsuario3(paramsGet: string = "") {
    return await this.http.post<any>(this.apiUrls.postCrearUsuarioMode2 + paramsGet, {}, {}).toPromise();
  }

  async postCrearUsuario(paramsGet, mode) {
    if(mode == 1) {
      return await this.http.post(this.apiUrls.postCrearUsuarioMode1 + paramsGet,{}, {}).toPromise();
    }
    else {
      /*
      var data = new FormData();
      data.append("Tipo", paramsGet.Tipo);
      data.append("CodValidarProductor", paramsGet.CodValidarProductor);
      */
      return await this.http.post(this.apiUrls.postCrearUsuarioMode2 + paramsGet, {}, {}).toPromise();
    }
  }

  // READ
  async getSexo(paramsGet: string = "") {
    return await this.http.get<Genero>(this.apiUrls.getSexo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getFumador(paramsGet: string = "") {
    return await this.http.get<Fumador>(this.apiUrls.getFumador + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getTipoPago(paramsGet: string = "") {
    return await this.http.get<Fumador>(this.apiUrls.getTipoPago + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getFrecuencia(paramsGet: string = "") {
    return await this.http.get<Fumador>(this.apiUrls.getFrecuencia + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getTipoRiesgo(paramsGet: string = "") {
    return await this.http.get<TipoRiesgo>(this.apiUrls.getTipoRiesgo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getCompaniaSeguros(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getCompaniaSeguros + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getMenuPermission(paramsGet: string = "") {
    return await this.http.get<Config>(this.apiUrls.getMenuPermission + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }
 
  // READ
  async getRamos(paramsGet: string = "") {
    return await this.http.get<Ramo>(this.apiUrls.getRamo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getSubRamos(paramsGet: string = "") {
    return await this.http.get<SubRamo>(this.apiUrls.getSubRamo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getMeses(paramsGet: string = "") {
    return await this.http.get<SubRamo>(this.apiUrls.getMes + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getAnyos(paramsGet: string = "") {
    return await this.http.get<SubRamo>(this.apiUrls.getAnyo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getPais(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getPais + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getEstado(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getEstado + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getCiudad(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getCiudad + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async getCodigoPostal(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getCodigoPostal + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  async postEnviarDocumentosPolizas(Datajosan) {
    var data = new FormData();
    // Post: Datajosan = [{"Poliza":[{"IdPoliza":"203071"},{"IdPoliza":"57095"},{"IdPoliza":"307277"}],"Email":"demisvergara@gmail.com"}]
    data.append("DataJson", JSON.stringify(Datajosan));
    return await this.http.post(this.apiUrls.postEnviarDocumentosPolizas, data, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getTipoLogin(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getTipoLogin + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  // READ
  async getPrefijoPoliza(paramsGet: string = "") {
    return await this.http.get<any>(this.apiUrls.getPrefijoPoliza + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
  }

  printPreview2(data, filename, type = 'application/pdf') {
    const blob = new Blob([data], { type : type });
    const file = new File([blob], filename, { type: type });
    download(data,filename, type);
  }

  printPreview3(data, filename, type = 'application/pdf') {
    download(`data:${type};base64,${data}`, filename);
  }

  dataURItoBlob (dataURI){
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]
  
    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
  
    // write the ArrayBuffer to a blob, and you're done
    const bb = new Blob([ab], { type: mimeString })
    return bb
  }

  forceDowndload(data, filename, type = 'application/pdf') {
    const pdfBlob = this.dataURItoBlob(data)
    const url = window.URL.createObjectURL(pdfBlob)
    const link = (document.getElementById("download-file") as HTMLLinkElement);
    link.href = url;
    link.title = filename;
    //link.setAttribute('download', filename);
    setTimeout(()=>{
      link.click()
    }, 500);
  }

  printPreview (data, filename, type = 'application/pdf') {
    let blob = null;
    blob = this.b64toBlob(data, type);
    const blobURL = URL.createObjectURL(blob);
    const theWindow = window.open(blobURL);
    const theDoc = theWindow.document;
    const theScript = document.createElement('script');
    function injectThis() {
        window.print();
    }
    theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
    theDoc.body.appendChild(theScript);
  }

  b64toBlob(content, contentType) {
      contentType = contentType || '';
      const sliceSize = 512;
      // method which converts base64 to binary
      const byteCharacters = window.atob(content); 

      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {
          type: contentType
      }); // statement which creates the blob
      return blob;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}
